export class FindingExclusionFilterConditions {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "resource",
            "baseName": "resource",
            "type": "FindingExclusionResourceFilter",
            "format": ""
        },
        {
            "name": "type",
            "baseName": "type",
            "type": "FindingExclusionTypeFilters",
            "format": ""
        },
        {
            "name": "detector",
            "baseName": "detector",
            "type": "FindingExclusionDetectorFilters",
            "format": ""
        },
        {
            "name": "value",
            "baseName": "value",
            "type": "FindingExclusionValueFilters",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return FindingExclusionFilterConditions.attributeTypeMap;
    }
    constructor() {
    }
}
